<template>
  <MpFlex
    width="100%"
    height="calc(100vh - 80px)"
    direction="column"
    align-items="center"
    justify-content="center"
    gap="4"
  >
    <img src="~/assets/images/error_404.png" width="200px" alt="404 Error" />
    <MpFlex direction="column" align-items="center">
      <MpText font-size="2xl" font-weight="bold">Whoops!</MpText>
      <MpText size="md"
        >Sorry, the page you were looking for does not exist.</MpText
      >
    </MpFlex>
    <MpButton @click="$router.push('/')">Go back to home</MpButton>
  </MpFlex>
</template>

<script>
export default {
  name: 'ErrorsPage404',
  props: {
    error: {
      type: Object,
      default: () => {},
    },
  },
  head() {
    return {
      title: "Sorry, the page you were looking for doesn't exist.",
      meta: [
        {
          name: 'viewport',
          content: 'width=device-width,initial-scale=1.0,minimum-scale=1.0',
        },
      ],
    }
  },
}
</script>
